var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-center",staticStyle:{"font-size":"0.7rem"}},[_vm._v(" "+_vm._s(_vm.date)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.time)+" "+_vm._s(_vm.place)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }